import { render, staticRenderFns } from "./AppBreadcrumbs.vue?vue&type=template&id=0f4ec31f&scoped=true"
import script from "./AppBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./AppBreadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./AppBreadcrumbs.vue?vue&type=style&index=0&id=0f4ec31f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4ec31f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/test-tripanels/clusterpanels/client-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f4ec31f')) {
      api.createRecord('0f4ec31f', component.options)
    } else {
      api.reload('0f4ec31f', component.options)
    }
    module.hot.accept("./AppBreadcrumbs.vue?vue&type=template&id=0f4ec31f&scoped=true", function () {
      api.rerender('0f4ec31f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/core/AppBreadcrumbs.vue"
export default component.exports